import { AxiosResponse } from 'axios';
import api from './utils/axios';
import generateCRUDOps from './utils/generateCrud';

export interface Disclaimer {
  id: number;
  title: string;
  text: string;
}

export interface DisclaimerResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Disclaimer[];
}

export interface DisclaimerCheck {
  disclaimer: number;
  is_checked: boolean;
}

export interface DisclaimerValidation {
  has_disclaimer: boolean;
  disclaimer_accepted: boolean;
}

const pathPrefix = '/';

const DisclaimerService = {
  // Use generated CRUD operations
  ...generateCRUDOps(pathPrefix, 'disclaimers'),

  // Custom endpoints
  validateDisclaimer: async (): Promise<
    AxiosResponse<DisclaimerValidation>
  > => {
    return api.get(`${pathPrefix}disclaimer-checks/validate/`);
  },

  updateDisclaimerCheck: async (
    data: DisclaimerCheck
  ): Promise<AxiosResponse<DisclaimerCheck>> => {
    return api.post(`${pathPrefix}disclaimer-checks/`, data);
  },
};

export default DisclaimerService;
